import { render } from "./cultureDialog.vue?vue&type=template&id=0a2413a7&scoped=true"
import script from "./cultureDialog.vue?vue&type=script&lang=js"
export * from "./cultureDialog.vue?vue&type=script&lang=js"

import "./cultureDialog.vue?vue&type=style&index=0&id=0a2413a7&lang=stylus&scoped=true"

import exportComponent from "/root/workspace/youyi_1_tob-teacher-fe_Ff2X/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a2413a7"]])

export default __exports__